import { render, staticRenderFns } from "./skills-right.vue?vue&type=template&id=61f3d7f1&scoped=true"
import script from "./skills-right.vue?vue&type=script&lang=js"
export * from "./skills-right.vue?vue&type=script&lang=js"
import style0 from "./skills-right.vue?vue&type=style&index=0&id=61f3d7f1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f3d7f1",
  null
  
)

export default component.exports